import styled from 'styled-components'
import { Settings } from 'react-slick'
import { media } from 'ui/utils/lib/mediaQuery'
import { Box } from 'ui/core'

export const Wrapper = styled.div<Settings>`
  position: relative;

  .slick-slider {
    display: flex;
    flex-direction: column;
  }
  .slick-list {
    overflow: hidden;
    display: block;
    order: 2;
  }
  .slick-list,
  .slick-slider {
    position: relative;
  }
  .slick-track {
    display: flex;
  }
  .slick-loading .slick-slide,
  .slick-loading .slick-track {
    visibility: hidden;
  }
  .slick-slider {
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }
  .slick-list {
    margin: 0;
    padding: 0;
  }
  .slick-list:focus {
    outline: 0;
  }
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }
  .slick-slider .slick-list,
  .slick-slider .slick-track {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .slick-track {
    top: 0;
    left: 0;
  }
  .slick-track:after,
  .slick-track:before {
    display: table;
    content: '';
  }
  .slick-track:after {
    clear: both;
  }
  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;
  }
  [dir='rtl'] .slick-slide {
    float: right;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-initialized .slick-slide {
    display: flex;
    flex-direction: column;
  }
  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }
  .slick-arrow.slick-hidden {
    display: none;
  }

  .slick-dots li button:before,
  .slick-next:before,
  .slick-prev:before {
    font-family: slick;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .slick-next,
  .slick-prev {
    font-size: 0;
    line-height: 0;
    top: 50%;
    width: 20px;
    height: 20px;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: 0;
    background: 0 0;
  }
  .slick-next:focus,
  .slick-next:hover,
  .slick-prev:focus,
  .slick-prev:hover {
    color: transparent;
    outline: 0;
    background: 0 0;
  }
  .slick-next:focus:before,
  .slick-next:hover:before,
  .slick-prev:focus:before,
  .slick-prev:hover:before {
    opacity: 1;
  }
  .slick-next.slick-disabled:before,
  .slick-prev.slick-disabled:before {
    opacity: 0.25;
  }
  .slick-next:before,
  .slick-prev:before {
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #fff;
  }
  .slick-prev {
    left: -25px;
  }
  [dir='rtl'] .slick-prev {
    right: -25px;
    left: auto;
  }
  .slick-prev:before {
    content: 'â†';
  }
  .slick-next:before,
  [dir='rtl'] .slick-prev:before {
    content: 'â†’';
  }
  .slick-next {
    right: -25px;
  }
  [dir='rtl'] .slick-next {
    right: auto;
    left: -25px;
  }
  [dir='rtl'] .slick-next:before {
    content: 'â†';
  }
  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }

  .slick-dots {
    width: 100%;
    list-style: none;
    text-align: center;
    order: 1;
  }

  .slick-dots li {
    position: relative;
    display: flex;
    align-items: center;
    width: 50%;
    height: 3px;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }
  .slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: #000;
  }
`

export const ContentWrapper = styled.div`
  padding: 0 15px;
`

export const SlideWrapper = styled(Box)`
  height: 250px;
  margin-bottom: ${({ theme }) => theme.grid.gutter.desktop}px;
`

export const DotsWrapper = styled(Box)`
  height: 3px;
  .slick-active {
    background-color: ${({ theme }) => theme.colors.white};
  }
`

export const Dots = styled.div`
  display: flex;
  width: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;

  &:before {
    content: '';
    height: 3px;
    background-color: transparent;
    width: 100%;
    transition: background-color 0.3s ease;
  }

  &:hover:before {
    background-color: ${({ theme }) => theme.colors.primary400};
  }
`

export const ImageBoxWrapper = styled.div`
  position: relative;
  height: 250px;
`
export const RightArrowWrapper = styled(Box)`
  transition: transform 0.3s ease;
`

export const SlideCard = styled(Box)`
  img {
    transition: transform 0.3s ease;
  }
  &:hover,
  &:active {
    img {
      transform: scale(1.05);
    }

    & ${RightArrowWrapper} {
      transform: translate(5px, 0);
    }
  }
`
export const ArrowWrapper = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    transition: transform 0.3s ease, color 0.3s ease;
  }
  &:hover {
    svg {
      color: ${({ theme }) => theme.colors.primary400};
      transform: scale(1.05);
    }
  }
`
export const InnerBoxWrapper = styled(Box)<{ minimumHeight?: number }>`
  min-height: 220px;
  ${media.desktopMedium} {
    min-height: 250px;
  }
  ${media.mobileSmallUp} {
    min-height: 150px;
  }
  ${media.customUp(2100)} {
    min-height: 270px;
  }
`
